import { Tabs, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import AdminNotificationsTab from './AdminNotificationsTab';
import NotificationTypesTab from './NotificationTypesTab';

const NotificationsPage = () => {
  const { t } = useTranslation(['notifications']);

  return (
    <div className="h-full flex flex-col">
      <Typography.Paragraph type="secondary" className="mb-4 text-xs">
        {t('pageDescription')}
      </Typography.Paragraph>
      <Tabs
        defaultActiveKey="types"
        items={[
          {
            key: 'types',
            label: t('typesTab'),
            children: <NotificationTypesTab />,
          },
          {
            key: 'sent',
            label: t('sentTab'),
            children: <AdminNotificationsTab />,
          },
        ]}
      />
    </div>
  );
};

export default NotificationsPage;
